import axios from 'axios'
import BrowserStore from 'store'
import { parseResponse } from '@/_helpers/utils.js'

export default {
  namespaced: true,
  state() {
    return {
      list: [],
      listLocales: [],
      availableLocales: ['en', 'ru', 'ja'],
      current_domain: '',
      domain_info: '',
      loadingImg: false,
      localesLoaded: false,
      errorImg: null,
      companyImage: null,
      requireAuthFinished: false,
      // isNewWay: true,
      register_confirm_auth_requested: false,
      registerStep: 'email',
      registerLoaded: false,
      isVideoBlured: false,
      metricsLoaded: false
    }
  },
  mutations: {
    clear: state => { state.current_domain = ''; },
    set_current_domain: (state) => {
      const host = window.location.hostname;
      if (!host) {
        state.current_domain = 'ru';
        return;
      }

      const hostSplitArray = host.split('.')
      let domain = hostSplitArray[hostSplitArray.length - 1]

      if (domain !== 'ru' && domain !== 'ai') {
        domain = 'ru'
      }

      state.current_domain = domain
    },

    setRequireAuthFinished: (state, v) => {
      state.requireAuthFinished = v;
    },

    setLocalesLoaded: (state, v) => {
      state.localesLoaded = v;
    },

    changeMetricsLoaded: (state, v) => {
      state.metricsLoaded = v;
    },

    set_register_confirm_auth_requested: (state, v) => {
      state.register_confirm_auth_requested = v;
    },

    setRegisterStep: (state, v) => {
      state.registerStep = v;
    },

    setRegisterLoaded: (state, v) => {
      state.registerLoaded = v;
    },

    setVideoBlur: (state, v) => {
      state.isVideoBlured = v;
    },

    set_domain(state) {
      const a = document.createElement('a');
      a.href = window.location.origin;
      let release = a.hostname.match(/release/i);
      let domain;

      if(release) {
        domain = a.hostname ? a.hostname.split('-')[1].split('.').shift() : '';
      } else {
        domain = a.hostname ? a.hostname.split('.').pop() : '';
      }

      if (domain !== 'ru' && domain !== 'ai' && domain !== 'jp') {
        domain = 'ru';
      }

      state.domain_info = domain;
    },

    add_key(state, v) {
      if(state.list.indexOf(v) === -1) {
        state.list.push(v);
      }
    },

    setListLocales(state, v) {
      state.listLocales.push(v);
    },

    saveCompanyRequest (state) {
      state.loadingImg = true;
      state.errorImg = null;
    },

    saveCompanyImageSuccess (state, data = {}) {
      state.companyImage = data
      state.loadingImg = false
    },

    saveCompanyImageFailure (state, err) {
      state.error = err;
      state.loading = false;
      state.errorImg = err;
      state.loadingImg = false;
      console.error(err)
    }
  },
  getters: {
    list: state => state.list,
    listLocales: state => state.listLocales,
    current_domain: state => state.current_domain,
    localesLoaded: state => state.localesLoaded,
    domain: state => state.domain_info,
    companyImage: state => state.companyImage,
    loadingImg: state => state.loadingImg,
    errorImg: state => state.errorImg,
    // isNewWay: state => state.isNewWay,
    requireAuthFinished: state => state.requireAuthFinished,
    // isVideoBlured: state => state.isVideoBlured,
    metricsLoaded: state => state.metricsLoaded,
    register_confirm_auth_requested: state => state.register_confirm_auth_requested,
    registerStep: state => state.registerStep,
    registerLoaded: state => state.registerLoaded,
  },
  actions: {
    save_tr_key(context, v) {
      return axios.post('/1.0/admin/translation-keys', {
        'translation_keys': [
          {
            'name': v
          }
        ]
      })
    },
    get_locales(context, val) {
      const locale = !!context.state.availableLocales.find(item => item === val) ? val : 'en';
      return axios.get(`/1.0/translations/${locale}`)
    },

    set_local_storage: (context, { name, value }) => {
      BrowserStore.set(name, value)
    },

    saveCompanyImage ({commit}, data) {
      const imageUrl = data.imageUrl
      data = new FormData()
      data.append('file', imageUrl, (new Date()).toJSON())

      commit('saveCompanyRequest')

      return axios.post(`1.0/company-files`, data)
        .then(response => parseResponse(response).data[0])
        .then(data => {
          commit('saveCompanyImageSuccess', data)
          return data;
        })
        .catch(err => {
          commit('saveCompanyImageFailure', err)
          return Promise.reject(err);
        })
    }
  }
}
